import React from 'react'
import {Context as SalesChannelsContext} from '../../contexts/SalesChannels'
import CreateGuide from './create'

import Stack from '@mui/material/Stack'
import Table from '@mui/material/Table'
import TableBody from '@mui/material/TableBody'
import TableCell from '@mui/material/TableCell'
import TableContainer from '@mui/material/TableContainer'
import TableHead from '@mui/material/TableHead'
import TableRow from '@mui/material/TableRow'
import Paper from '@mui/material/Paper'
import Toolbar from '@mui/material/Toolbar'
import Typography from '@mui/material/Typography'
import Tooltip from '@mui/material/Tooltip'
import IconButton from '@mui/material/IconButton'
import AddIcon from '@mui/icons-material/Add'
import RefreshIcon from '@mui/icons-material/Refresh'
import DeleteSweepIcon from '@mui/icons-material/DeleteSweep'

const GuidesToolbar = (props) => {
  const { numSelected, add, clean, refresh } = props

  return (
    <Toolbar
      sx={{
        pl: { sm: 2 },
        pr: { xs: 1, sm: 1 },
      }}
    >
      {numSelected > 0 ? (
        <Typography
          sx={{ flex: '1 1 100%' }}
          color="inherit"
          variant="subtitle1"
          component="div"
        >
          {numSelected} selected
        </Typography>
      ) : (
        <Typography
          sx={{ flex: '1 1 100%' }}
          variant="h6"
          id="tableTitle"
          component="div"
        >
          Envíos usuario final
        </Typography>
      )}
      <Tooltip title="Actualizar">
        <IconButton onClick={refresh}>
          <RefreshIcon />
        </IconButton>
      </Tooltip>
      <Tooltip title="Añadir Guía">
        <IconButton onClick={add}>
          <AddIcon />
        </IconButton>
      </Tooltip>
      <Tooltip title="Limpiar">
        <IconButton onClick={clean}>
          <DeleteSweepIcon />
        </IconButton>
      </Tooltip>
    </Toolbar>
  )
}

const Guides = () => {
	const AmazonSalesChannel = React.useContext(SalesChannelsContext)
  const { guides, refresh, clean } = AmazonSalesChannel.guides
  const [open, setOpen] = React.useState(false)
  const openD = (s) => {
    setOpen(true)
  }
  return (
    <Stack>
      <GuidesToolbar numSelected={0} add={openD} refresh={refresh} clean={clean}/>
      <TableContainer component={Paper}>
        <Table sx={{ minWidth: 650 }} aria-label="simple table">
          <TableHead>
            <TableRow>
  						<TableCell alignt="left">Código</TableCell>
              <TableCell alignt="left">Pedido</TableCell>
              <TableCell alignt="left">Fecha</TableCell>
              <TableCell alignt="left">Costo</TableCell>
  						<TableCell alignt="left">Email</TableCell>
              <TableCell alignt="left">Estado</TableCell>
              <TableCell alignt="left">Cliente</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {guides.map((guide) => (
              <TableRow
                key={guide.code}
                sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
              >
                <TableCell align="left">{guide.code}</TableCell>
                <TableCell align="left">{guide.purchase}</TableCell>
                <TableCell align="left">{guide.date?new Date(guide.date).toISOString().split('T')[0]:'-'}</TableCell>
                <TableCell align="left">MXN {guide.cost?Number(guide.cost)/100:0}</TableCell>
                <TableCell align="left">{guide.email}</TableCell>
                <TableCell align="left">{guide.status}</TableCell>
                <TableCell align="left">{guide.client?guide.client.name:'-'}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
      <CreateGuide open={open} close={() => setOpen(false)}/>
    </Stack>
  )
}
export default Guides